import { useEffect, useState } from "react"
import { _AppointmentManualPdf, _single } from "../../../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../../../core/services/dataBean/useDataBean"
import { BasicTable } from "../../../../../theme/Component/BasicTable"
import useModal, { MODAL_md, MODAL_SM } from "../../../../../theme/Component/hooks/useModal"
import { ListMenu } from "../../../../../theme/Component/ListMenu"
import { Modal } from "../../../../../theme/Component/Modal"
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm"
import { toast } from "react-toastify"
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch"
import { FileInput } from "../../../../../theme/Component/FileInput"
import { FileService } from "../../../../../../core/services/FileService"
import { BasicButton } from "../../../../../theme/Component/BasicButton"

interface Props {
    _IDAppointmentManual: number;
}

export const AppointmentManualPdf = ({ _IDAppointmentManual }: Props) => {

    const { instance, lista, setBean, setLista, bean } = useDataBean(_AppointmentManualPdf)
    const modal = useModal("", MODAL_md);
    const modalConfirm = useModal("Confirmar Eliminación del manual seleccionado", MODAL_SM);
    const modalPublished = useModal("Confirmar publicación del manual seleccionado", MODAL_SM);
    const fileService = new FileService();

    useEffect(() => {
        getLista();
    }, [_IDAppointmentManual])

    const getLista = () => {
        if (state) {


            let props = {
                IDAppointmentManual: _IDAppointmentManual,
                State: state
            }
            instance.getAppointmentManualPdfCatalogPorPropiedades(props, null).then(
                (resp: any) => {
                    resp.forEach((manuales) => {
                        const manual = manuales.DataBeanProperties;
                        const url = fileService.getUrlFile(
                            manual.MediaContext, manual.Media
                        );
                        manual.EnityDoc = `<a href='${url}' target='_blank'>${manual.Media}</a>`
                    });
                    setLista(resp)
                }
            ).catch(
                err => {
                    toast.error(err)
                }
            )
        } else {
            setLista([])
        }
    }

    const create = () => {
        setBean({
            IDAppointmentManual: _IDAppointmentManual,
            IDEmployee: _single.getAccountID(),
            State: 1,
        });
        modal.setModal({ ...modal.modal, view: true, name: "Crear Manual" });
    }

    const deleteItem = (_state: number) => {
        // instance.deleteAppointmentManualPdf(bean.IDAppointmentManualPdf).then(
        //     (resp: any) => {
        //         getLista();
        //         modalConfirm.close();
        //     }
        // ).catch(
        //     err => { toast.error(err) }
        // )

        bean.State = _state;
        editaItem();
        modalConfirm.close();
        modalPublished.close();
    }

    const editaItem = () => {
        instance.updateAppointmentManualPdf(bean).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDAppointmentManualPdf', visible: true },
        { title: 'Archivo', property: 'EnityDoc', visible: true },
        { title: 'Version del manual', property: 'VersionManual', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: (_single.canEdit() && bean.State === 1), evento: () => { modal.setModal({ ...modal.modal, view: true, name: "Editar Manual" }) } },
            { titulo: 'Publicar', icono: 'ri-check-line', visible: _single.canEdit(), evento: () => { modalPublished.open(); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalConfirm.open(); } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [state, setState] = useState<number>(1)

    return (
        <>
            <div className="row">
                <div className="col-md-8">
                    <label>Estado</label>
                    <select className="form-select" value={state} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : 1;
                        setState(value)
                    }}>
                        <option value="">...</option>
                        <option value="1">Creado</option>
                        <option value="2">Publicado</option>
                        <option value="3">Eliminado</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
                </div>
            </div>

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={editaItem}>
                <div className="row">
                    <div className="col-12">
                        <FileInput onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext }) }} Media={bean.Media} MediaContext={bean.MediaContext} label="Manual a Cargar" />
                    </div>
                    <div className="col-12">
                        <label>Version del Manual</label>
                        <input type="text" className="form-control" value={bean.VersionManual} onChange={(e) => { setBean({ ...bean, VersionManual: e.target.value }) }} />
                    </div>
                </div>
            </Modal>
            <ModalConfirm modal={modalConfirm.modal} updateModal={modalConfirm.setModal} eventModal={() => { deleteItem(3) }}>
                <strong>Eliminar item: {bean.IDAppointmentManualPdf}</strong>
            </ModalConfirm>
            <ModalConfirm modal={modalPublished.modal} updateModal={modalPublished.setModal} eventModal={() => { deleteItem(2) }}>
                <strong>Publicar manual: {bean.IDAppointmentManualPdf}</strong>
            </ModalConfirm>
        </>
    )
}